<template>

    <div>

        <table>
            <thead>
                <tr>
                    <td>
                        <div class="header-space">&nbsp;</div>
                    </td>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>
                        <b-row class="mt-3 p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="policy-number-background  col-4" style="height:55px">
                                    <div class="mt-3 fontsize">
                                        {{ data.policyInfo[0].TARIFFGROUP }}
                                    </div>
                                </td>
                                <td class=" col-8 header_text text-center border-value font-weight-bolder" style="height:55px">
                                    <div class="mt-3 fontsize">
                                        {{ data.policyInfo[0].POLICYPRODUCT }}
                                    </div>

                                </td>

                                <th class="title-box text-center mt-1 col-12">
                                    <div class="row pt-2 pb-2">
                                        <div class="col-4"></div>
                                        <div class="col-8 nino-mtavruli fontsize"> {{$t('Insurer')}}</div>
                                    </div>
                                </th>

                                <td class=" col-4 description-box pt-3">
                                    <div class="">{{$t('companyname')}}</div>
                                    <div class="">{{$t('taxnumber')}}</div>
                                </td>
                                <td class=" col-8  text-center border-value p-0 pt-1">
                                    <div class="pt-2 short_fields">{{ data.policyInfo[0].COMPNAME }}</div>
                                    <div class="pt-2">{{ data.policyInfo[0].COMPSOCCART }}</div>
                                </td>
                                <!--Owner-->
                                <th class="title-box text-center mt-1 col-12">
                                    <div class="row pt-2 pb-2">
                                        <div class="col-4"></div>
                                        <div class="col-8 nino-mtavruli"> {{$t('policyholder')}}</div>
                                    </div>
                                </th>
                                <td class=" col-4 description-box  ">
                                    <div>
                                        <div class="pt-2">{{$t('namesurname')}}</div>
                                        <div class="pt-2">{{$t('pnumber')}}</div>
                                        <div class="pt-2">{{$t('mob')}}</div>
                                    </div>
                                </td>

                                <td class=" col-8 text-center border-value p-0 ">
                                    <div class="pt-2 short_fields">{{ data.policyInfo[0].CUSTOMERNAME  }}</div>
                                    <template v-if="data.policyInfo[0].CUSTOMERSOCCARD ===''">
                                        <div class="pt-2 short_fields" style="color:white">{{empty}} </div>
                                    </template>
                                    <template v-else>
                                        <div class="pt-2 short_fields"> {{ data.policyInfo[0].CUSTOMERSOCCARD }}</div>
                                    </template>
                                    <div class="pt-2"> {{ data.policyInfo[0].CUSTOMERPHONENUMBER }}</div>
                                </td>

                                <template v-for="(item,index) in data.clients">
                                    <template v-if="item.Status ==='მოსარგებლე'">
                                        <td class="description  mt-1 col-12">
                                            <div class="row pt-2 pb-2">
                                                <div class="col-12">
                                                    და აგრეთვე ყველა ის ფიზიკური და/ან იურიდიული პირი და/ან პირთა გაერთიანება, რომლებმაც გააფორმეს გენერალური და/ან საკრედიტო
                                                    ხელშეკრულება სს პროკრედიტ ბანკთან წინამდებარე პოლისში მითითებული დაზღვევის ობიექტის უზრუნველყოფით
                                                </div>

                                            </div>
                                        </td>
                                        <th class="title-box text-center mt-1 col-12">
                                            <div class="row pt-2 pb-2">
                                                <div class="col-4"></div>
                                                <div class="col-8 nino-mtavruli"> {{$t('beneficiarypcbuser')}}</div>
                                            </div>
                                        </th>
                                    </template>
                                    <template v-if="item.Status ==='მსესხებელი'">
                                        <th class="title-box text-center mt-1 col-12">
                                            <div class="row pt-2 pb-2">
                                                <div class="col-4"></div>
                                                <div class="col-8 nino-mtavruli"> {{$t('beneficiarypcbborrower')}}</div>
                                            </div>
                                        </th>
                                    </template>

                                    <td class=" col-4 description-box ">
                                        <div>
                                            <div class="pt-2 pb-2">{{$t('namesurname')}}</div>
                                            <template v-if="item.Status ==='მსესხებელი'">
                                                <div class="pt-2 pb-2">{{$t('address')}}</div>
                                            </template>
                                            <div class="pt-2 pb-2">{{$t('pnumber')}}</div>
                                            <div class="pt-2">{{$t('mob')}}</div>
                                        </div>
                                    </td>

                                    <td class=" col-8 text-center border-value p-0 ">
                                        <div class=" pt-2 short_fields">{{ item.Name  }}</div>
                                        <template v-if="item.Status ==='მსესხებელი'">
                                            <div class="pt-2 pb-2 short_fields">{{ item.Saddress  }}</div>
                                        </template>
                                        
                                        <template v-if="item.Soccart ===''">
                                            <div class="pt-2 pb-2 short_fields" style="color:white">{{empty}} </div>
                                        </template>
                                        <template v-else>
                                            <div class="pt-2 pb-2 short_fields"> {{ item.Soccart }}</div>
                                        </template>
                                        <div class="pt-2"> {{ item.Phone }}</div>
                                    </td>
                                </template>
                               

                                <th class="title-box text-center mt-1 col-12">
                                    <div class="row pt-2 pb-2">
                                        <div class="col-4"></div>
                                        <div class="col-8 nino-mtavruli"> {{$t('vehicleinformation')}}</div>
                                    </div>
                                </th>
                                <td class=" col-4 description-box ">

                                    <div class="pt-2 pb-2">{{$t('automodelPcb')}}</div>
                                    <div class="pt-2 pb-2">{{$t('vincode')}}</div>
                                    <div class="pt-2 pb-2">{{$t('year')}}</div>
                                    <div class="pt-2 pb-2">{{$t('carregnumber')}}</div>
                                    <div class="pt-2 pb-2">{{$t('suminsurePrc')}}</div>
                                </td>

                                <td class=" col-8 text-center border-value p-0 ">
                                    <div class="pt-2 pb-2 short_fields">{{ data.policyInfo[0].CARMARKVALUE }}</div>
                                    <div class="pt-2 pb-2 short_fields"> {{ data.policyInfo[0].VINCODE }}</div>
                                    <div class="pt-2 pb-2 short_fields">{{ data.policyInfo[0].PRODUCTIONDATE}}</div>
                                    <div class="pt-2 pb-2 short_fields"> {{ data.policyInfo[0].PLATENUMBER1 }}</div>
                                    <div class="pt-2 pb-2"> {{ data.casco[0].amount }}</div>
                                </td>

                                <template v-for="(risk,index) in data.tpl_ma_Risks">
                                    <th class="title-box text-center mt-1 col-12" :key="index">
                                        <div class="row pt-2 pb-2">
                                            <div class="col-4"></div>
                                            <div class="col-8 nino-mtavruli"> {{ risk.risk }}</div>
                                        </div>
                                    </th>

                                    <td class="col-4 description-box" :key="index">
                                        <div style="font-size: 10pt; padding: .5rem !important;">{{$t('suminsured')}}</div>
                                        <div v-if="risk.limit" style="font-size: 10pt; padding: .5rem !important; ">{{$t('sublimitper')}}</div>
                                    </td>
                                    <td class="col-8 text-center border-value p-0" :key="index">
                                        <div :class="{short_fields:risk.limit} " style="font-size: 10pt; padding: .5rem !important;">{{ risk.amount }}</div>
                                        <div class="pt-2" v-if="risk.limit" style="font-size: 10pt; ">{{ risk.limit }}</div>
                                    </td>

                                </template>
                            </b-col>
                        </b-row>

                       

                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <div class=" col-12 mt-1 p-0 ">
                                    <table class=" m-0 p-0 border-0" id="insured-risk">
                                        <thead class="description-box">
                                            <tr>
                                                <th rowspan="2" class="col-9 pl-1 border-top-0 border-left-0 border-bottom">
                                                    <div class="pl-1 risk-header-1 nino-mtavruli ">{{$t('insuredrisk')}}</div>
                                                </th>
                                                <th rowspan="2" class="col-1 text-center nino-mtavruli border-top-0 border-bottom">{{$t('insurancestatus')}}</th>
                                                <th colspan="2" class="text-center risk-header-2 nino-mtavruli border-right-0 border-top-0 ">{{$t('deductible')}}</th>
                                            </tr>
                                            <tr>
                                                <th class="col-1 text-center risk-header-2 border-bottom nino-mtavruli">{{$t('loss')}}</th>
                                                <th class="col-1 text-center risk-header-2 border-bottom nino-mtavruli">{{$t('totalloss')}}</th>
                                                <!--<th class="col-1 text-center risk-header-2 border-right-0 border-bottom nino-mtavruli" style="font-size: 10pt !important">{{$t('totalloss')}}</th>-->
                                            </tr>
                                        </thead>
                                        <tbody class="green-outline">
                                            <template v-for="(risk, index) in data.insuredRisks">
                                                <!--risk-->
                                                <tr :key="index" class="col-9">
                                                    <td class="p-0">
                                                        <div class="d-flex p-0">
                                                            <div v-if="risk.img" class="pb-1 pr-1 p-l-t-1">
                                                                <img :src='"../assets/img/"+risk.img+"-sq.svg"' width="20">
                                                            </div>
                                                            <div :key="index" :class="{sub_risk_text_color: risk.img, 'p-1' :!risk.img}" class="pl-1 pr-1 " style="font-size: 10pt;">
                                                                {{ risk.risk }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td :key="index" class=" text-center" style="font-size: 10pt;">{{ risk.riskstate }}</td>
                                                    <!--<td :key="index" class=" text-center" style="font-size: 10pt;">{{ risk.cnorate }}</td>-->
                                                    <template v-if="risk.fR_Total === null || risk.fR_Total == '' || risk.fR_Total == '0 %'">
                                                          <td :key="index" class=" text-center" style="font-size: 10pt;" >{{risk.cnorate }}</td>
                                                          <td :key="index" class=" text-center" style="font-size: 10pt;">{{  risk.fR_Total == '0 %' ? risk.fR_Total : '-'}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td :key="index" class=" text-center" style="font-size: 10pt;">{{risk.fR_Type}}  {{risk.fR_Total}} მინ.{{risk.cnorate }}</td>
                                                        <td :key="index" class=" text-center" style="font-size: 10pt;">{{ risk.fR_Total }}</td>
                                                    </template>
                                                  
                                                    <!--<td :key="index" class=" text-center" style="font-size: 10pt;">{{ risk.cnoback }}</td>-->
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <div class=" col-12 mt-1 p-0 no-break">
                                    <table class="m-0 p-0 border-0" id="extra-risk">
                                        <thead class="description-box">
                                            <tr>
                                                <th rowspan="2" class="col-9 pl-1 border-bottom border-left-0 border-top-0">
                                                    <div class="pl-1 risk-header-1 nino-mtavruli">{{$t('additionalrisksPcb')}}</div>
                                                </th>
                                                <th rowspan="2" class="col-1 text-center border-bottom border-top-0 nino-mtavruli">{{$t('insurancestatus')}}</th>
                                                <th colspan="2" class=" text-center risk-header-2 border-bottom-0 border-top-0 p-0 nino-mtavruli"></th>
                                            </tr>
                                            <tr>
                                                <th class="text-center border-top-0 border-bottom risk-header-5 nino-mtavruli" style="font-size: 10pt!important;">{{$t('limit')}}</th>
                                                <th class="text-center border-top-0 border-bottom border-right-0 risk-header-3 nino-mtavruli" style="font-size: 10pt !important;">{{$t('deductible')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody class="green-outline">
                                            <template v-for="(risk, index) in data.innovativeRisks">
                                                <!--risk-->
                                                <tr :key="index" class="col-9">
                                                    <td class="p-0">
                                                        <div class="d-flex p-0">
                                                            <div v-if="risk.img" class="pb-1 pr-1 p-l-t-1">
                                                                <img :src='"../assets/img/"+risk.img+"-sq.svg"' width="20">
                                                            </div>
                                                            <div :key="index" class="pl-2 " style="font-size: 10pt;">
                                                                {{ risk.risk }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td :key="index" class="text-center" style="font-size: 10pt;">{{ risk.riskstate }}</td>
                                                    <td :key="index" class="text-center" style="font-size: 10pt;" :colspan="risk.box">{{risk.risk =='საევაკუაციო მომსახურება სადაზღვევო შემთხვევისას' ? 'ულიმიტო': risk.amount }}</td>
                                                    <td :key="index" class="text-center" style="font-size: 10pt;" v-if="risk.box===1">{{ risk.cnoback}}</td>
                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="col-12 pl-1 border-0 description-box mt-1" v-if="data.policyInfo[0].ADDNOTE">
                                    <div class="nino-mtavruli pt-2 pb-2" style="font-weight: bold;">{{$t('additionalinformation')}}</div>
                                </td>
                                <td class=" col-12  border-value p-0 " v-if="data.policyInfo[0].ADDNOTE">
                                    <div class=" p-1">
                                        {{ data.policyInfo[0].ADDNOTE }}
                                    </div>
                                </td>

                                <td class="col-12 pl-1 border-0 description-box mt-1 " v-if="data.policyInfo[0].DRIVERRULES ||data.policyInfo[0].OWNNAME">
                                    <div class="nino-mtavruli pt-2 pb-2" style="font-weight:bold;">{{$t('authorizeddriver')}}</div>
                                </td>
                                <td class="col-12  border-value p-0 " v-if="data.policyInfo[0].DRIVERRULES">
                                    <div class=" p-1">
                                        {{ data.policyInfo[0].DRIVERRULES }}
                                    </div>
                                </td>
                                <!--<td class="col-12 pl-1  border-value p-0 " v-if="data.policyInfo[0].OWNNAME">
                                    <div class=" border-top-0 ">
                                        {{ data.policyInfo[0].OWNNAME}}
                                    </div>
                                </td>-->
                                <td class="col-12 pl-1 border-0 description-box mt-1">
                                    <div class="nino-mtavruli pt-2 pb-2" style="font-weight:bold;">{{$t('insurancearea')}}</div>
                                </td>
                                <div class="p-1">
                                    {{ data.policyInfo[0].COUNTRYS }}
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="col-6 pl-1 border-0 description-box mt-1  nino-mtavruli">
                                    <div class="nino-mtavruli pt-2 pb-2" style="font-weight:bold;">{{$t('yearpremium')}}</div>
                                </td>
                                <td class="col-6 pl-1 description-box border-bottom-0 border-top-0 border-right-0 mt-1 nino-mtavruli">
                                    <div class="nino-mtavruli pt-2 pb-2">{{$t('paymentcount')}}</div>
                                </td>
                                <td class="col-6 pl-1 border-value ">
                                    {{ data.policyInfo[0].INSURANCEPREMIUMS }}
                                </td>

                                <td class="col-6 pl-1 border-value ">
                                    {{ data.policyInfo[0].PAYMENTCOUNT }}
                                </td>
                                <td class="col-12 pl-1 border-0 description-box mt-1 nino-mtavruli pt-2 pb-2" style="font-weight:bold;">
                                    {{$t('paymentschedule')}}
                                </td>

                                <div class="col-12 mt-1 m-0 d-flex justify-content-between payment">
                                    <div class="payment-block row p-0  " v-if="data.payment.length>=2">
                                        <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                                            {{$t('date')}}
                                        </div>
                                        <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                                            {{$t('amount')}}
                                        </div>
                                        <template v-for="(payment,index) in data.payment.slice(0, Math.round( data.payment.length/2))">
                                            <!--//.slice(0, data.payment.length/2)">-->

                                            <td :key="index" class="col-6 pl-1">
                                                {{ payment.PAYDATE }}
                                            </td>
                                            <td :key="index" class="col-6 pl-1">
                                                {{ payment.PAYAMAUNT }}
                                            </td>
                                        </template>
                                    </div>

                                    <div class="payment-block row p-0 " v-if="data.payment.length>=2">
                                        <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                                            {{$t('date')}}
                                        </div>
                                        <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                                            {{$t('amount')}}
                                        </div>


                                        <template v-for="(payment,index) in data.payment.slice(Math.round(data.payment.length/2), data.payment.length)">
                                            <!--//.slice(0, data.payment.length/2)">-->

                                            <td :key="index" class="col-6 pl-1">
                                                {{ payment.PAYDATE }}
                                            </td>
                                            <td :key="index" class="col-6 pl-1">
                                                {{ payment.PAYAMAUNT }}
                                            </td>
                                        </template>
                                    </div>

                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="mt-3 p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <div class="col-12 mt-1">
                                    <div class="row" v-if="data.payment.length<2">
                                        <template v-for="(payment,index) in data.payment">
                                            <!--//.slice(0, data.payment.length/2)">-->
                                            <div :key="index" class="col-2 pl-1 payment-title nino-mtavruli">
                                                {{$t('date')}}
                                            </div>
                                            <div :key="index" class="col-4 pl-1">
                                                {{ payment.PAYDATE }}
                                            </div>
                                            <div :key="index" class="col-2 pl-1 payment-title nino-mtavruli">
                                                {{$t('amount')}}
                                            </div>
                                            <div :key="index" class="col-4 pl-1">
                                                {{ payment.PAYAMAUNT }}
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="col-12 pl-1 border-0 description-box mt-1 nino-mtavruli pt-2 pb-2" style="font-weight:bold;">
                                    {{$t('coverfrom')}}
                                </td>

                                <td class="col-12 border-0">
                                    <div class="row  border-value">

                                        <div class="col-2 pl-1 payment-title border-0 " style="font-size:10pt">
                                            {{$t('from')}}
                                        </div>
                                        <div class="col-4" style="font-size:10pt">
                                            {{ data.policyInfo[0].FROMDATE }}
                                        </div>
                                        <div class="col-2 pl-1 payment-title border-0 " style="font-size:10pt">
                                            {{$t('including')}}
                                        </div>
                                        <div class="col-4" style="font-size:10pt">
                                            {{ data.policyInfo[0].TODATE }}
                                        </div>

                                    </div>
                                </td>
                            </b-col>
                        </b-row>


                        <b-row class="mt-3 p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <b-col md="12" sm="12" class="p-2 content-header mt-4 mt-sm">
                                    <div class="col-md-12 col-sm-12 text-center nino-mtavruli">პოლისის გაცემის საფუძვლები</div>
                                </b-col>

                            </b-col>
                        </b-row>
                        <b-row class=" p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="description  col-4">
                                    <div class="">
                                        ავტომობილის საკრედიტო დაზღვევის პირობები ვერსია 1.20
                                    </div>
                                </td>

                                <td class=" col-8  text-center border-value ">

                                    <div class="text-center nino-mtavruli">
                                        <div style="cursor: pointer; color: -webkit-link; " @click="openLink()">{{data.policyInfo[0].Condition}}</div>
                                    </div>
                                </td>


                            </b-col>
                            <b-col cols="11" offset="1" class="row form-font">
                                <td class="description  col-4">
                                    <div class="">
                                        გენერალური ხელშეკრულება
                                    </div>
                                </td>

                                <td class=" col-8  text-center border-value ">
                                    <div class="text-center nino-mtavruli">
                                        <div>{{data.policyInfo[0].CONTNUM}}</div>
                                    </div>
                                </td>


                            </b-col>
                        </b-row>

                        <b-row class="p-0 col-12">
                            <b-col cols="11" offset="1" class="row form-font">
                                
                                <td class=" col-12  p-0 ">
                                    <div class=" p-1 border-green">
                                        მე დამზღვევი/დაზღვეული, ვაცნობიერებ, რომ პოლისი შეიცავს ჩემს მიერ მოწოდებულ მონაცემებს და ვადასტურებ, რომ ისინი სრულყოფილი
                                        და სწორია. აგრეთვე, ვაცხადებ, რომ დეტალურად განმემარტა სს "არდი დაზღვევა"-ს ავტომობილის საკრედიტო დაზღვევის პირობები, ვეთანხმები და
                                        ვკისრულობ მასში გათვალისწინებული ვალდებულებების სრულად შესრულების ვალდებულებას. ამასთან, თანახმა ვარ, რომ მრავალწლიანი
                                        სესხის შემთხვევაში, პოლისი განახლდეს ავტომატურად, გარდა იმ შემთხვევისა, თუ არ იცვლება(იზრდება) პოლისით გათვალისწინებული
                                        სადაზღვევო გადასახადი (სადაზღვევო პრემია). დაზღვეული/მსესხებელი უფლებამოსილებას ანიჭებს ბანკს, მისი ნებისმიერი ანგარიშიდან,
                                        მისი თანხმობის გარეშე, ჩამოწეროს სადაზღვევო პრემიის თანხა და განახორციელოს ანგარიშსწორება სადაზღვევო კომპანიასთან.
                                        სადაზღვევო კომპანიასთან ანგარისსწორება ხდება ეროვნულ ვალუტაში (ლარში), თუ მსესხებლის ანგარიშზე არსებული თანხა სხვა ვალუტაშია,
                                        ბანკი უფლებამოსილია მსესხებლის ხარჯზე მოახდინოს სავალუტო ერთეულიდან 'მეორეში თანხის კონვერტაცია, ანგარიშიდან თანხის
                                        ჩამოწერის დღისთვის ბანკში მოქმედი კომერციული კურსის შესაბამისად, ასევე ჩამოწეროს კონვერტაციის საკომისიო (არსებობის
                                        შემთხვევაში).
                                    </div>
                                </td>
                            </b-col>
                        </b-row>
                        <b-row class="col-12  p-0">
                            <b-col cols="11" offset="1" class="row form-font">
                                <b-col md="12" sm="12" class="p-2 content-header mt-4 mt-sm">
                                    <div class="col-md-12 col-sm-12 text-center nino-mtavruli">ხელმოწერები</div>
                                </b-col>
                                <signature :roleid="this.role" class="col-12" />
                            </b-col>
                        </b-row>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td>
                        <div class="footer-space">&nbsp;</div>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div class="page-header">
            <b-col cols="12" class=" row p-0 mt-3 header11">
                <b-col cols="12 d-flex pb-4">
                    <div class="header header_logo col-2 p-0 "></div>
                    <div class=" header header_text col-10 p-0 d-flex">
                        <h5 class="ml-md-5 nino-mtavruli font-weight-bold mt-3" style="color: #007960; font-size:23px !important">{{$t('pcbslogan')}}</h5>
                    </div>
                </b-col>
            </b-col>
        </div>
        <div class="page-footer">
            <b-row class="m-0 mt-3 footer col-12 pl-0">
                <b-col cols="11" offset="1" class="pl-0 mt-2 ">
                    <div class="d-flex justify-content-between align-items-center pt-4 pb-4">

                        <template v-if="$t('isgeo') == 1">
                            <img src="../assets/img/ardi-logo.svg" width="110">
                           
                        </template>
                        <template v-else>
                            <img src="../assets/img/logoEn1.svg" width="110">
                        </template>

                       <!-- <img src="../assets/img/ukraina.svg" width="150" class="">-->

                        <!--<div class="footer-slogan align-content-center" style="color: #007960; font-size: 20px;">{{$t('footerslogan')}}</div>-->
                        <div>
                             <img src="../assets/img/ardi_slogan.png" width="320">
                        </div>
                    </div>
                </b-col>

            </b-row>
        </div>

    </div>

</template>

<script>
    //import InsuredRisks from "./InsuredRisks";
    import Signature from "@/Pcb/components/Signature";

    export default {
        name: "Contract",
        components: {
            //'insured-risks': InsuredRisks,
            Signature
        },
        data() {
            return {
                empty: "0",
                data: null,
                id: this.$route.params.cont,
                cust: this.$route.params.cust,
                role: this.$route.params.role,
            }
        },
        mounted() {
            this.$http.get(`/policy/GetPcbPolicyInfo/${this.id}/${this.cust}`).then((r) => {
                this.data = r.data;
            }).catch((e) => {
                console.log(e)
            })
        }
    }
</script>

<style scoped>
    @import "~bpg-nino-mtavruli";

    .nino-mtavruli {
        font-family: "BPG Nino Mtavruli", sans-serif;
        font-size: 16px;
    }





    .header11, .header-space,
    .footer-space {
        height: 100px;
    }

    .header11 {
        position: fixed;
        top: 0;
    }

    .fontsize {
        font-size: 16px
    }

    @media print {
        div {
            break-inside: avoid !important;
        }

        td {
            break-inside: avoid !important;
        }


        .footer {
            break-inside: avoid !important;
            page-break-after: always;
            page-break-before: always;
        }
    }

    .page-footer {
        position: absolute;
        bottom: 5px;
    }

    .value-background-lrb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .page-header {
        position: absolute;
        top: 5px;
    }

    .footer {
        position: fixed;
        bottom: 0;
    }

    .content-header {
        background-color: #005745;
        color: #fff;
        font-weight: bold;
    }

    h5 {
        font-size: 15pt;
        color: #007960;
    }

    .company {
        font-size: 17pt;
    }

    .watermark {
        background: url("../assets/logo.png") center center no-repeat;
        background-size: 100px;
    }

    .blur {
        background-color: rgba(255, 255, 255, 0.50);
    }

    .slogan {
        color: #14836D;
        text-transform: uppercase !important;
        -webkit-font-feature-settings: 'case' on !important;
        font-feature-settings: 'case' on !important;
    }

    .header {
        height: 60px;
    }

    .header_logo {
        background: url("../assets/img/header.svg") no-repeat center;
        background-size: cover;
        width: 107px;
    }

    .risk-header-1 {
        font-size: 12pt !important;
    }

    .risk-header-2 {
        font-size: 11pt !important;
    }

    .risk-header-3 {
        font-size: 11pt !important;
        padding: 5px;
    }

    .risk-header-4 {
        font-size: 10pt !important;
    }

    .risk-header-5 {
        font-size: 10pt !important;
        padding: 5px 6px;
    }

    .header_text {
        background: #D9D8D6;
    }

    .payment-block {
        width: 51%;
    }

    .title-box {
        background: #005745;
        color: #fafafa;
    }

    .conditions {
        color: #ffffff;
        font-size: 11pt;
    }

    .risk-header-3 {
    }

    .form-box {
        background: #005745;
    }

    .description-box {
        background: #007960;
        color: #ffffff;
    }

    .right-border {
        border-right: 1px solid #EEEEEE;
    }

    .sub_risk_text_color {
        color: #00A887;
    }

    .form-font {
        font-size: 10pt;
    }

    .border-value {
        border: 1px solid #D9D8D6;
    }

    .payment td {
        /*width: 25%;*/
        border: 1px solid #EEEEEE;
    }

    .p-l-t-1 {
        padding-top: 1px;
        padding-left: 1px;
    }

    .border-green {
        border: 2px solid #00a987 !important;
    }



    .payment div {
        font-size: 12pt;
    }

    .green-border-2 {
        border: 2px solid #00A886;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .h-center {
        transform: translateX(29%);
    }

    .short_fields:nth-child(n) {
        border-bottom: 1px solid #D9D8D6;
    }

    /*#print-header {
      padding: 15px 0;
      display: table-header-group;
    }

    #print-footer {
      display: table-footer-group;
      padding-bottom: 15px;
    }*/

    /*.print-body{
      margin-bottom: 5rem;
    }*/

    table {
        width: 100%;
    }
    /*
    .no-break{
      page-break-inside: avoid;
    }
    */

    #insured-risk > thead.border-bottom-0 {
        border-bottom: 1px solid #007960 !important;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }

    .policy-number-background {
        background-color: #00a987;
        color: #fff;
        font-size: 11pt;
    }

    th, .green-border {
        border: 1px solid #00A886;
        border-collapse: collapse;
        font-size: 10pt;
    }

    .green-outline {
        /*outline: 1px solid #00A886;*/
    }


    /*table#insured-risk, table#extra-risk {
      outline: 1px solid #00A886;
    }*/
    .border-bottom {
        border-bottom: 1px solid #007960 !important;
    }


    table#insured-risk td, table#extra-risk td {
        /*font-size: 8.3pt !important;*/
        border: 1px solid #EEEEEE;
    }

    /*#extra-risk>tbody>tr>td{
      border-top:0 !important;*/
    /*border-left: 0 !important;*/
    /*page-break-inside: avoid;
      page-break-after: auto
    }*/
    #extra-risk > tbody > tr > td:nth-child(1) {
        padding-top: 2px !important;
    }

    /*table {
      page-break-after: auto
    }

    tr ,td{
      page-break-inside: avoid;
      page-break-after: auto
    }

    @media print {

      table {
        page-break-after: auto
      }

      tr {
        page-break-inside: avoid;
        page-break-after: auto
      }

      td {
        page-break-inside: avoid;
        page-break-after: auto
      }
    }*/
</style> 